import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {CustomObjectTypeEntityModel} from "../custom-object-type-entity.model";
import {OutletCustomObjectTypeSearchModel} from "../outlet-custom-object-type-search.model";
import {CustomObjectTypeSearchPageComponent} from "./custom-object-type-search-page.component";

@Component({
    selector: "wbo-outlet-custom-object-type-search-page",
    templateUrl: "./custom-object-type-search-page.component.html",
    providers: [provideSearchModel(OutletCustomObjectTypeSearchModel), provideEntityModel(CustomObjectTypeEntityModel)]
})
export class OutletCustomObjectTypeSearchPageComponent extends CustomObjectTypeSearchPageComponent {
}
